import {WebsiteTourConstant} from "../redux_constants/websitetour.constant";


export const startWebsiteTour = () => ({
    type: WebsiteTourConstant.ACTIVATE,
})

export const stopWebsiteTour = () => ({
    type: WebsiteTourConstant.DEACTIVATE,
})

export const startWebsiteTourForScan = () => ({
    type: WebsiteTourConstant.ACTIVATE_FOR_SCAN,
})

export const stopWebsiteTourForScan = () => ({
    type: WebsiteTourConstant.DEACTIVATE_FOR_SCAN,
})